import Filter from './Filter'

export default class UserFilter extends Filter {
	constructor (filters) {
		super(filters)

		return this.get('page', null, '?page')
			.get('searchKeyword', null, '&keyword')
			.get('emotion', null, '&emotion_value', this.filterEmotion)
			.get('sortBy', 'value', '&sort_by', this.filterSortBy)
			.get('sortType', 'value', '&sort_type', this.filterSortType)
			.get('activeLevel', 'value', '&active_level', this.filterActiveLevel)
			.get('country', 'value', '&country', this.filterCountry)
			.get('age', null, '&age', this.filterAge)
			.get('device', null, '&device_type', this.filterDevice)
			.get('gender', null, '&gender')
			.get('itemsPerPage', null, '&count')
			.init()
	}

	filterAge ({ filter }) {
		// const { ageTo, ageFrom } = value.reduce((acc, ageRange) => {
		// 	const [ ageFrom, ageTo ] = [...ageRange.value.split('-')]
		// 	acc.ageFrom.push(ageFrom)
		// 	acc.ageTo.push(ageTo)

		// 	return acc
		// }, { ageTo: [], ageFrom: [] })
		const { age } = filter.filters
		if (age) {
			const [from, to] = age
			if (from !== 0 || to !== 0) {
				filter.apiQuery += `&age_from=${from}&age_to=${to}`
				filter.routerQuery.age_from = from
				filter.routerQuery.age_to = to
			}
		}

		return filter
	}

	filterSortType ({ filter, value }) {
		const sortType = value === 'Ascending' ? 'ASC' : 'DESC'
		filter.apiQuery += `&sort_type=${sortType}`
		filter.routerQuery.sort_type = value
		return filter
	}

	filterSortBy ({ filter, value }) {
		const sortBy = value.toLowerCase().split(' ').join('_')
		filter.apiQuery += `&sort_by=${sortBy}`
		filter.routerQuery.sort_by = value
		return filter
	}

	filterActiveLevel ({ filter }) {
		const { activeLevel } = filter.filters

		if (activeLevel !== 'All') {
			filter.apiQuery += `&active_level=${activeLevel}`
			filter.routerQuery.active_level = activeLevel
		}

		return filter
	}

	filterCountry ({ filter }) {
		const { country } = filter.filters

		if (country.length) {
			const countries = country.map(item => item.name).join()
			filter.apiQuery += `&country=${countries}`
			filter.routerQuery.country = countries
		}

		return filter
	}

	filterEmotion ({ filter }) {
		const { emotion } = filter.filters

		if (emotion.length) {
			const emotions = emotion.join()
			filter.apiQuery += `&emotion_value=${emotions}`
			filter.routerQuery.emotion_value = emotions
		}

		return filter
	}

	filterDevice ({ filter, value }) {
		const { device } = filter.filters

		if (device.length) {
			const devices = value.join().toLowerCase()
			filter.apiQuery += `&device_type=${devices}`
			filter.routerQuery.device_type = devices
		}
		return filter
	}
}
